import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sparkles, Home, Briefcase, Building2, LogOut } from "lucide-react";

const tabs = [
  { to: "/app/home", icon: Home, label: "Domov", id: "top-home", end: true },
  { to: "/app/jobs", icon: Briefcase, label: "Ponuky pre teba", id: "top-jobs" },
  { to: "/app/companies", icon: Building2, label: "Firmy", id: "top-companies" },
];

export function CandidateHeader() {
  const { logout } = useAuth();
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/90 border-b border-slate-200" data-testid="candidate-top-nav">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 flex items-center gap-3 py-3">
        <div className="flex items-center gap-2 mr-1">
          <div className="h-8 w-8 rounded-lg bg-blue-700 flex items-center justify-center"><Sparkles className="text-white" size={16} /></div>
          <span className="font-head font-bold hidden sm:block">Profeeluj<span className="text-blue-700"> AI</span></span>
        </div>
        <nav className="flex items-center gap-1 overflow-x-auto min-w-0 flex-1 no-scrollbar">
          {tabs.map((t) => (
            <NavLink key={t.to} to={t.to} end={t.end} data-testid={t.id}
              className={({ isActive }) => `inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-2 text-sm font-semibold transition-colors ${isActive ? "bg-blue-50 text-blue-700" : "text-slate-500 hover:bg-slate-50 hover:text-slate-800"}`}>
              <t.icon size={16} /> {t.label}
            </NavLink>
          ))}
        </nav>
        <button data-testid="candidate-logout-top" onClick={() => { logout(); nav("/"); }}
          className="shrink-0 text-slate-400 hover:text-slate-700 transition-colors"><LogOut size={18} /></button>
      </div>
    </header>
  );
}

export function OpportunitiesShell({ children }) {
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <CandidateHeader />
      <main className="mx-auto max-w-5xl px-4 sm:px-6 py-6 md:py-8">{children}</main>
    </div>
  );
}
